import { SxProps } from '@mui/material';
import React from 'react';
import { cssToken } from '@youhelp-ru/ui';
import { AppTheme } from '../../theme';

const name = 'Tabs';

export const TabsTokens = {
  ActiveTextColor: cssToken(name, 'active-color'),
  TextColor: cssToken(name, 'text-color'),
  HoverColor: cssToken(name, 'hover-color'),
  BorderColor: cssToken(name, 'border-color'),
  IndicatorColor: cssToken(name, 'indicator-color'),
};

export type TabItemId = string | number;

export interface TabItem<B = unknown, I extends TabItemId = TabItemId> {
  id: I;
  label: React.ReactNode;
  body: B;
}

export type TabsProps<B = unknown, I extends TabItemId = TabItemId> = {
  items: TabItem<B, I>[];
  itemId?: TabItemId;
  isActive?: boolean;
  beforeHeaderContent?: React.ReactNode;
  sx?: SxProps<AppTheme>;
  itemSx?: SxProps<AppTheme>;
  keepAllItemsMounted?: boolean;
  onItemChange?: (activeItemId: I) => void;
  renderItemLabel?: (payload: { isActive?: boolean; value: React.ReactNode; item: TabItem<B, I> }) => React.ReactNode;
  renderBody?: (payload: { activeItemId?: I; children: React.ReactNode }) => React.ReactNode;
  renderItemBody?: (payload: { isActive?: boolean; value: B }) => React.ReactNode;
};
